import Immutable from 'seamless-immutable';
import _ from 'lodash';
import { baseCollection } from '../../common/collections';

import PageTemplateModel from './page-template-model';

/**
 * Takes an array of page template objects and turns each object into a Model and the array into a Collection of the models
 * Doesn't work with array of already created Models
 * Most commonly used in a selector when reading an array of pages from the redux state tree and you want to turn them into a Collection
 * @param {Array} pageTemplates - an array of plain pages to wrap into a PageCollection
 */
function create(pageTemplates = []) {
  return Immutable(_.map(pageTemplates, PageTemplateModel.create));
}

/**
 * Transforms and array of backend page template objects into a PageTemplateCollection
 * @param {Object[]} pageTemplates - backend formatted page templates
 * @returns {PageTemplate[]}
 */
function deserialize(pageTemplates = []) {
  return Immutable(_.map(pageTemplates, PageTemplateModel.deserialize));
}

/**
 * Transforms a PageTemplateCollection into an array of backend page template objects
 * @param {Page[]} pageTemplates
 * @returns {Object[]}
 */
function serialize(pageTemplates) {
  return _.map(pageTemplates, pageTemplate => PageTemplateModel.serialize(pageTemplate));
}

export default {
  ...baseCollection,
  create,
  deserialize,
  serialize,
};
